import { render } from "./manage-direct-debit-data.vue?vue&type=template&id=89e0fe44"
import script from "./manage-direct-debit-data.vue?vue&type=script&lang=js"
export * from "./manage-direct-debit-data.vue?vue&type=script&lang=js"
script.render = render

export default script